import { Link, Outlet, createRootRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { Wordmark } from "@/components/shell/brand";
import { QueryBoundary } from "@/components/shell/page";
import { Button } from "@/components/ui/button";

export const Route = createRootRoute({
  component: RootLayout,
  notFoundComponent: NotFound,
});

function RootLayout() {
  return (
    <QueryBoundary fallback={(retry) => <Crash onRetry={retry} />}>
      <Outlet />
    </QueryBoundary>
  );
}

function Crash({ onRetry }: { onRetry: () => void }) {
  const { t } = useTranslation();
  return (
    <main className="mx-auto flex min-h-dvh max-w-sm flex-col justify-center gap-4 px-6">
      <Wordmark />
      <p className="text-muted-foreground">{t("states.error")}</p>
      <div>
        <Button variant="outline" onClick={onRetry}>
          {t("actions.retry")}
        </Button>
      </div>
    </main>
  );
}

function NotFound() {
  const { t } = useTranslation();
  return (
    <main className="mx-auto flex min-h-dvh max-w-sm flex-col justify-center gap-4 px-6">
      <Wordmark />
      <p className="text-muted-foreground">{t("states.notFound")}</p>
      <div>
        <Button variant="outline" asChild>
          <Link to="/">{t("actions.backHome")}</Link>
        </Button>
      </div>
    </main>
  );
}
